import {
  ARPageShell
} from "./chunk-FXF7X2MJ.mjs";
import {
  FOODS,
  characterSpec,
  prefetchCharacter
} from "./chunk-C7FE5SD3.mjs";

// src/components/Pages/FeedingGame/FeedingGame.tsx
import React2, { useEffect } from "react";

// src/components/Pages/arShared/RewardRevealPanel.tsx
import React from "react";
var RewardRevealPanel = ({
  reward
}) => {
  const text = (reward ?? "").trim();
  if (!text) return null;
  return /* @__PURE__ */ React.createElement("p", { className: "mt-3 rounded-2xl bg-amber-100 px-4 py-3 text-lg font-bold text-amber-900 ring-1 ring-amber-300" }, "\u2728 ", text);
};
var RewardRevealPanel_default = RewardRevealPanel;

// src/components/Pages/FeedingGame/FeedingGame.tsx
var loadFeedingGameView = () => import("./FeedingGameView-X2CB4UWJ.mjs");
var FeedingGameView = React2.lazy(loadFeedingGameView);
var warmUpFeedingGameView = () => {
  void loadFeedingGameView().catch(() => void 0);
};
var DEFAULT_FEEDING_CREATURE = "pumpkin";
var DEFAULT_TARGET_FEEDS = 6;
function FeedingGame({
  page,
  trailEvent,
  nextPage,
  editorMode = false
}) {
  const creature = page.creature ?? DEFAULT_FEEDING_CREATURE;
  const spec = characterSpec(creature);
  const name = page.creatureName?.trim() || `the ${spec.label.toLowerCase()}`;
  const food = FOODS[spec.food ?? "candy"];
  const reward = page.rewardChest ? page.rewardText?.trim() : void 0;
  useEffect(() => {
    prefetchCharacter(creature);
  }, [creature]);
  return /* @__PURE__ */ React2.createElement(
    ARPageShell,
    {
      page,
      eventPrefix: "Feed Me",
      trailEvent,
      nextPage,
      editorMode,
      warmUp: warmUpFeedingGameView,
      copy: {
        startLabel: `Feed ${name}`,
        permissionPurpose: `to find ${name} floating nearby`,
        motionPurpose: `so ${name} can float in the right place`,
        permissionDescription: `We use your camera (and motion on iOS) to float ${name} in the world around you.`,
        skipText: "Are you sure you want to skip the feeding game?",
        loadingLabel: `Waking ${name}\u2026`,
        emoji: spec.emoji,
        logTag: "FeedingGame",
        completeTitleFallback: "Full at last!",
        lookAgainLabel: "Play again",
        noCameraLabel: "Play without the camera"
      },
      completeExtra: /* @__PURE__ */ React2.createElement(RewardRevealPanel_default, { reward }),
      renderView: ({ onFound, onComplete, sceneKey, noCamera }) => /* @__PURE__ */ React2.createElement(
        FeedingGameView,
        {
          key: sceneKey,
          page,
          editorMode,
          noCamera,
          foodLabel: food.label,
          onFirstFeed: onFound,
          onFed: () => trailEvent("Feed Me: Fed"),
          onMissed: () => trailEvent("Feed Me: Missed"),
          onChestOpened: () => trailEvent("Feed Me: Chest Opened"),
          onComplete
        }
      )
    }
  );
}

export {
  RewardRevealPanel_default,
  DEFAULT_FEEDING_CREATURE,
  DEFAULT_TARGET_FEEDS,
  FeedingGame
};
//# sourceMappingURL=chunk-WIVZKXML.mjs.map